import { observable } from 'mobx';
import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsShoppingPwaFlightInformationResults, FlightsLoadedPriceSummary } from '__generated__/api';
import FlightsJourneyDetailsDynamicElements = FlightsShoppingPwaFlightInformationResults.FlightsJourneyDetailsDynamicElements;
import DynamicElementsGroupTrackEventAnalytics = FlightsShoppingPwaFlightInformationResults.DynamicElementsGroupTrackEventAnalytics;
import DynamicElementsGroups = FlightsShoppingPwaFlightInformationResults.DynamicElementsGroups;
import DynamicElements = FlightsShoppingPwaFlightInformationResults.DynamicElements;
import FlightsInformationDynamicElements = FlightsShoppingPwaFlightInformationResults.FlightsInformationDynamicElementsInlineFragment;
import FlightsLoadedPriceSummaryType = FlightsLoadedPriceSummary.Fragment;

export class DynamicElementsStore extends Store {
  @observable public dynamicElementsGroups: DynamicElementsGroups[];
  public dynamicElementsMap: Map<string, DynamicElements>;
  @observable public selectedIdentifier: string;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public initialiseDynamicStoreCache() {
    if (this.dynamicElementsGroups && this.dynamicElementsGroups.length > 0) {
      this.dynamicElementsMap = new Map();
      this.dynamicElementsGroups.map(element => {
        this.dynamicElementsMap.set(element.identifier, element.dynamicElements);
      });
    }
  }

  public getPriceSummaryById(identifier: string): FlightsLoadedPriceSummaryType {
    if (this.dynamicElementsMap && this.dynamicElementsMap.has(identifier)) {
      const dynamicElement = this.dynamicElementsMap.get(identifier);

      return (dynamicElement as FlightsInformationDynamicElements).priceSummary;
    }
  }

  public getFlightsJourneyDetailsById(identifier: string): FlightsJourneyDetailsDynamicElements[] {
    if (this.dynamicElementsMap && this.dynamicElementsMap.has(identifier)) {
      return this.dynamicElementsMap.get(identifier).flightsJourneyDetailsDynamicElements;
    }
  }
  public getDynamicElementsGroupTrackEventAnalytics(identifier: string): DynamicElementsGroupTrackEventAnalytics {
    return Array.from(this.dynamicElementsMap.entries()).filter(entry => entry?.[0].includes(identifier))?.[0]?.[1]?.[
      'dynamicElementsGroupTrackEventAnalytics'
    ];
  }

  public setSelectedIdentifier(selectedIdentifier: string) {
    this.selectedIdentifier = selectedIdentifier;
  }

  public getSelectedAncillaryId(baseOfferAncillaryID?: string): string {
    if (this.selectedIdentifier) {
      try {
        return this.dynamicElementsGroups?.filter(element => element.identifier === this.selectedIdentifier)[0]
          .ancillaryId;
      } catch (error) {
        // do nothing
      }
    }

    return baseOfferAncillaryID;
  }
}
